import React, { useState, useRef, useEffect, useCallback } from "react";
import { ReactComponent as CheckIcon } from "images/svg/check.svg";

const FilterDropdown = ({ isVisible, setIsVisible, setFilter }) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const modalRef = useRef(null);

  const categories = [
    { value: "all", label: "All" },
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" },
  ];

  const handleCategoryClick = (category) => {
    setSelectedCategory(category.value);
  };

  const handleShowResult = () => {
    const filterValue = selectedCategory === "all" ? "" : `priority=${selectedCategory}`;
    setFilter(filterValue);
    setIsVisible(false);
  };

  const handleClickOutside = useCallback((event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  }, [setIsVisible]);

  useEffect(() => {
    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, handleClickOutside]);

  if (!isVisible) return null;

  const modalStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1001,
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        }}
      />
      <div className="category-dropdown" style={modalStyle} ref={modalRef}>
        <h6>Filter</h6>
        <ul>
          {categories.map((category) => (
            <li
              key={category.value}
              onClick={() => handleCategoryClick(category)}
              className={
                selectedCategory === category.value
                  ? "category-item selected-category"
                  : "category-item"
              }
            >
              {category.label}
              {selectedCategory === category.value && (
                <span className="selected-tag">
                  <CheckIcon className="check-icon" />
                  Selected
                </span>
              )}
            </li>
          ))}
        </ul>
        <button
          onClick={handleShowResult}
          className="leader-board-button"
          disabled={!selectedCategory}
        >
          Show Result
        </button>
      </div>
    </>
  );
};

export default FilterDropdown;